/* 🤖 this file was generated by svg-to-ts */
export const matIconKingBed: {
  name: 'king-bed';
  data: string;
} = {
  name: 'king-bed',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 12c0-1.1-.9-2-2-2V7c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L4 19h1l.67-2h12.67l.66 2h1l.67-2H22v-5zm-4-2h-5V7h5v3zM6 7h5v3H6V7zm-2 5h16v3H4v-3z"/></svg>`
};
